module.exports = '<svg width="44" height="32" viewBox="0 0 44 32"><path d="M36.952 12.293h-.229C35.528 4.903 29.476 0 22.171 0 14.85 0 8.787 4.902 7.612 12.293H7.39c-4.326 0-7.39 5.2-7.39 9.854 0 5.42 4.41 9.854 9.854 9.854h24.634c5.444 0 9.804-4.41 9.804-9.829 0-4.58-3.104-9.878-7.341-9.878z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/cloud-1.js
// module id = 1072
// module chunks = 14